import HeaderInner from "../comp/head-navs-inner";
import ViewContentSmall from "../comp/view-content-sm";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import TeamSearchModule from "../comp/team-search";

export default function TeamSearch() {

  return (
    <>
      <HeaderInner name={'Search'} link={'/bz/home'}/>
      <ViewContentSmall 
        content={
          <>
            <ViewDividerSmall />
            <TeamSearchModule />

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
    </>
  )
}